module.exports = __webpack_public_path__ + "img/floor_f16_02.846cb683.png";